import { useState, useEffect } from 'react'
import { useWindowSize } from './WindowSize'

export const useIntersection = (element: any, options: any) => {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const size = useWindowSize()

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        setIsIntersecting(entries[0].isIntersecting)
      }, options
    )

    element.current && observer.observe(element.current)

    return () => {
      element.current && observer.unobserve(element.current)
    }
  }, [size[0], size[1]]) // size change

  return isIntersecting
}
